import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { STORE_DETAILS_TEAM_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { NavigationService } from 'src/app/core/navigation.service';
import { StoreMembership } from 'src/app/core/store-memberships.service';

@Component({
  selector: 'app-store-details-team-data-table',
  templateUrl: './store-details-team-data-table.component.html',
  styleUrls: ['./store-details-team-data-table.component.scss'],
})
export class StoreDetailsTeamDataTableComponent {
  @Input() sellers: StoreMembership[] = [];
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();
  displayed_columns: string[] = STORE_DETAILS_TEAM_TABLE_COLUMNS;

  constructor(private navigation_service: NavigationService) {}

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  getFullName(seller: StoreMembership): string {
    return `${seller.seller_firstname} ${seller.seller_lastname}`;
  }

  onSellerDetailClick(seller_id: string) {
    this.navigation_service.toSellerDetails(seller_id);
  }
}
